import { AuditedEntity } from '../../audited-entity'
import { PropertyConf } from '../../properties/conf/property-conf'
import { WorkStationConfiguration } from './configurations/work-station-configuration'

export class WorkStationGateway {
  public type: string

  public enabled: boolean

  public connectionString: string
}

export class WorkStation extends AuditedEntity {
  public id: string

  public facility: string
  public number: string

  public type: string

  public name: string
  public description: string

  public properties: PropertyConf[] = []

  public gateway = new WorkStationGateway()

  public configurations: WorkStationConfiguration[] = []
}
